import { useEffect } from 'react';

/**
 * This hook is used to abort an effect when the component is unmounted.
 * @param {Function} effect - The effect to run.
 * @param {Array} deps - The dependencies to watch.
 * @returns {Callback} - function to abort the effect
 */
export const useAbortableEffect = (effect, deps = []) => {
  useEffect(() => {
    const controller = new AbortController();

    const cleanup = effect(controller.signal);

    return () => {
      controller.abort();
      if (cleanup) {
        cleanup();
      }
    };
  }, deps);
};

export const isAbortError = (error) => error.code === 'ERR_CANCELED';
